/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlUseCase = {
    ChatOps: 'chat_ops',
    CheckAttackSimulation: 'CHECK_ATTACK_SIMULATION',
    CheckBreach: 'CHECK_BREACH',
    CheckPlannedChange: 'CHECK_PLANNED_CHANGE',
    ContainEndpointIsolate: 'contain_endpoint_isolate',
    ContainEndpointLock: 'contain_endpoint_lock',
    ContainUserDisable: 'contain_user_disable',
    ContainUserResetPassword: 'contain_user_reset_password',
    ContainUserRevokeSessions: 'contain_user_revoke_sessions',
    ContainFileDelete: 'contain_file_delete',
    ContainFileQuarantine: 'contain_file_quarantine',
    CreateTicket: 'CREATE_TICKET',
    EnrichFile: 'ENRICH_FILE',
    EnrichIp: 'ENRICH_IP',
    EnrichDetection: 'enrich_detection',
    OnConnect: 'ON_CONNECT',
    OnEnable: 'ON_ENABLE',
    OnDisable: 'ON_DISABLE',
    GetDetections: 'get_detections',
    GetEndpoint: 'get_endpoint',
    GetEndpoints: 'get_endpoints',
    GetLogs: 'get_logs',
    GetUser: 'get_user',
    GetUsers: 'get_users',
    Internal: 'INTERNAL',
    InternalAuthCheck: 'INTERNAL_AUTH_CHECK',
    Other: 'OTHER',
    LogParser: 'LOG_PARSER',
    DetectionParser: 'DETECTION_PARSER',
    SendMessage: 'SEND_MESSAGE',
    UncontainEndpointUnisolate: 'uncontain_endpoint_unisolate',
    UncontainFileUnquarantine: 'uncontain_file_unquarantine',
    UncontainUserEnable: 'uncontain_user_enable',
    UpdateDetectionSource: 'update_detection_source',
    UpdateTicket: 'UPDATE_TICKET',
    Webhook: 'webhook',
    RefreshDetection: 'refresh_detection',
    GetRules: 'get_rules'
} as const;
export type ControlUseCase = typeof ControlUseCase[keyof typeof ControlUseCase];


export function ControlUseCaseFromJSON(json: any): ControlUseCase {
    return ControlUseCaseFromJSONTyped(json, false);
}

export function ControlUseCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUseCase {
    return json as ControlUseCase;
}

export function ControlUseCaseToJSON(value?: ControlUseCase | null): any {
    return value as any;
}

